let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dhHRl")).then(() => parcelRequire('2jHH0'));